import { WidgetWrapper } from '@agentselly/ui';

interface Props {
  readonly groups: {
    readonly name: string;
    readonly pois: {
      readonly icon: string;
      readonly name: string;
      readonly distance: string;
    }[];
  }[];
}

export function PartnerRegionPointsOfInterestWidget(props: Props) {
  // TODO: Implement this

  return (
    <WidgetWrapper>
      <pre>{JSON.stringify(props, null, 2)}</pre>
    </WidgetWrapper>
  );
}
